<template>
  <div>
    <basic-container>
      <avue-crud
        :option="option"
        :data="list"
        ref="crud"
        @refresh-change="refreshChange"
        @sortable-change="sortableChange"
      >
        <!-- 自定义搜索框 -->
        <template slot="mySearch">
          <!-- //^ ^--------------搜索栏配置-------------^ ^ -->
          <div class="search-contain">
            <div class="search-left">
              <el-input
                size="large"
                v-model="searchParams.search"
                clearable
                style="margin-left: -10px; padding: 0"
                placeholder="策略ID&名称"
              ></el-input>
              <!-- <el-select style="margin-left: 20px;" clearable placeholder="策略场景-取字典">
                <el-option label="启用" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select> -->
              <el-select
                size="large"
                v-model="searchParams.status"
                style="margin-left: 20px"
                clearable
                placeholder="生效状态"
              >
                <el-option label="生效" :value="1"></el-option>
                <el-option label="失效" :value="0"></el-option>
              </el-select>
            </div>
            <div class="search-right">
              <el-button
                style="margin-left: 10px"
                v-auth="'RECOMMEND_STRATEGY_SEARCH'"
                type="primary"
                size="small"
                @click="handleSearch"
                >搜索</el-button
              >
              <el-button
                v-auth="'RECOMMEND_STRATEGY_ADD'"
                type="primary"
                size="small"
                @click="handleAdd"
                >新增</el-button
              >
            </div>
          </div>
        </template>
        <!-- 自定义表格列 -->
        <template #mediaName="scope">
          <span style="color: blue">{{ scope.row.mediaName }}</span>
        </template>
        <!-- 自定义表格操作栏 -->
        <template #menu="{ row }">
          <el-button
            v-auth="'RECOMMEND_STRATEGY_EDIT'"
            type="text"
            size="small"
            @click="handleEdit(row)"
            >编辑</el-button
          >
          <el-button
            v-auth="'RECOMMEND_STRATEGY_DEL'"
            type="text"
            size="small"
            @click="detailDel(row.id)"
            >删除</el-button
          >
        </template>
      </avue-crud>
      <ElementPagination
        style="margin-bottom: 20px"
        :current-page="searchParams.current"
        :page-size="searchParams.size"
        :total="searchParams.total"
        :page-sizes="[10, 20, 30, 40, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </basic-container>
    <!-- //^ ^--------------新增/编辑的对话框-------------^ ^ -->
    <el-dialog
      :title="isEdit ? '编辑策略' : '新增策略'"
      append-to-body
      :visible.sync="addVisible"
      width="60%"
      @closed="closeAddDialog"
    >
      <el-form
        ref="addForm"
        inline
        :model="addForm"
        :rules="addFormRules"
        label-width="130px"
      >
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item name="1">
            <template slot="title">
              <h3 class="add-title">基础配置</h3>
            </template>
            <div class="add-item">
              <el-form-item prop="name" label="策略名称：">
                <el-input style="width: 30vw" v-model="addForm.name"></el-input>
              </el-form-item>
              <!-- <el-form-item prop="scene" label="策略场景：">
                <el-select clearable v-model="addForm.scene" placeholder="请选择策略场景-取字典">
                  <el-option label="启用" :value="1"></el-option>
                  <el-option label="禁用" :value="0"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item prop="descr" label="策略描述：">
                <el-input
                  style="width: 30vw"
                  v-model="addForm.descr"
                ></el-input>
              </el-form-item>
            </div>
          </el-collapse-item>
          <el-collapse-item name="2">
            <template slot="title">
              <h3 class="add-title">媒资配置</h3>
            </template>
            <div class="add-item error-update">
              <el-form-item
                prop="tacticsMedias"
                label-width="120px"
                label="媒资选择："
              >
              </el-form-item>
              <el-form-item class="media-select">
                <div style="display: flex; align-items: baseline">
                  <el-input
                    clearable
                    size="small"
                    style="width: 120px; margin-right: 10px"
                    placeholder="媒资名称"
                    v-model="mediaSelectParams.name"
                  ></el-input>
                  <el-select
                    clearable
                    size="small"
                    style="width: 120px; margin-right: 10px"
                    v-model="mediaSelectParams.type"
                    placeholder="媒资类型"
                  >
                    <!-- 0其它 1电影 2电视剧 3动画片 4短剧 5电影票 6团购券 -->
                    <el-option label="电影" :value="1"></el-option>
                    <el-option label="电视剧" :value="2"></el-option>
                    <el-option label="动画片" :value="3"></el-option>
                    <el-option label="短剧" :value="4"></el-option>
                    <el-option label="电影票" :value="5"></el-option>
                    <el-option label="团购券" :value="6"></el-option>
                    <el-option label="其它" :value="0"></el-option>
                  </el-select>
                  <el-select
                    clearable
                    size="small"
                    style="width: 120px"
                    v-model="mediaSelectParams.source"
                    placeholder="媒资来源"
                  >
                    <el-option
                      :key="item.id"
                      v-for="item in mediaSourceList"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <el-button
                    style="margin-left: 30px"
                    size="small"
                    type="primary"
                    @click="mediaConfSearch"
                    >搜索</el-button
                  >
                  <el-button
                    style="margin-left: 10px"
                    type="info"
                    size="small"
                    @click="mediaConfReset"
                    >重置</el-button
                  >
                  <el-button
                    style="margin-left: 10px"
                    size="small"
                    @click="handleMediaSelect"
                    >媒资选择</el-button
                  >
                </div>
                <div
                  v-if="addForm.tacticsMedias.length"
                  style="display: flex; flex-direction: column; width: 100%"
                >
                  <avue-crud
                    style="width: 100%"
                    :option="dragOption"
                    :data="addForm.tacticsMedias"
                    ref="crud"
                    @sortable-change="sortChange"
                  >
                    <!-- 自定义搜索框 -->
                    <template slot="mySearch"> </template>
                    <!-- 自定义表格列 -->
                    <template #status="scope">
                      <span
                        :class="{
                          'gary-text': scope.row.valid === false,
                          'green-text':
                            scope.row.status === 1 && scope.row.valid === true,
                        }"
                        >{{ scope.row.status === 1 ? "上线" : "下线" }}
                        {{ scope.row.valid === false ? "(未生效)" : "" }}</span
                      >
                    </template>
                    <template #name="scope">
                      <span style="color: #3370ff">{{ scope.row.name }}</span>
                    </template>
                    <template #horizontalImg="scope">
                      <el-image
                        v-if="scope.row.horizontalImg"
                        :src="scope.row.horizontalImg"
                        :previewSrcList="[scope.row.horizontalImg]"
                        alt=""
                      />
                      <el-image
                        v-else-if="scope.row.horizontalImgLarge"
                        :src="scope.row.horizontalImgLarge"
                        :previewSrcList="[scope.row.horizontalImgLarge]"
                        alt=""
                      />
                      <el-image
                        v-else-if="scope.row.horizontalImgSmall"
                        :src="scope.row.horizontalImgSmall"
                        :previewSrcList="[scope.row.horizontalImgSmall]"
                        alt=""
                      />
                      <span v-else>暂无图片</span>
                    </template>
                    <template #showOption="{ row }">
                      <div v-if="!row.mySelect && !row.mySave">
                        <span>{{
                          row.useType === 1
                            ? "片花"
                            : row.useType === 2
                            ? "分集"
                            : ""
                        }}</span>
                        <span>{{
                          row.useType === 1
                            ? `(${row.trailer.id ? row.trailer.id : ""})`
                            : row.useType === 2
                            ? `(${row.episode.id ? row.episode.id : ""})`
                            : ""
                        }}</span>
                        <span
                          v-if="
                            row.useType === 1 && row.trailer.id
                              ? true
                              : row.useType === 2 && row.episode.id
                          "
                          style="
                            text-decoration: underline;
                            color: #3370ff;
                            cursor: pointer;
                          "
                          @click="handleMediaSelectPreview(row)"
                          >&nbsp;预览</span
                        >
                      </div>
                      <div v-else-if="!row.mySelect && row.mySave">
                        <span>{{
                          row.useType === 1
                            ? "片花"
                            : row.useType === 2
                            ? "分集"
                            : ""
                        }}</span>
                        <span>{{
                          row.useType === 1
                            ? `(${row.trailerId ? row.trailerId : ""})`
                            : row.useType === 2
                            ? `(${row.episodeId ? row.episodeId : ""})`
                            : ""
                        }}</span>
                        <span
                          v-if="
                            row.useType === 1 && row.trailerId
                              ? true
                              : row.useType === 2 && row.episodeId
                          "
                          style="
                            text-decoration: underline;
                            color: #3370ff;
                            cursor: pointer;
                          "
                          @click="handleMediaSelectPreview(row)"
                          >&nbsp;预览</span
                        >
                      </div>
                      <div v-else-if="row.mySelect && !row.mySave">
                        <span>{{
                          row.useType === 1
                            ? "片花"
                            : row.useType === 2
                            ? "分集"
                            : ""
                        }}</span>
                        <span>{{
                          row.useType === 1
                            ? `(${
                                row.firstTrailer
                                  ? row.firstTrailer.id
                                  : row.trailer
                                  ? row.trailer.id
                                  : ""
                              })`
                            : row.useType === 2
                            ? `(${
                                row.firstEpisode
                                  ? row.firstEpisode.id
                                  : row.episode
                                  ? row.episode.id
                                  : ""
                              })`
                            : ""
                        }}</span>
                        <span
                          v-if="
                            row.useType === 1 && row.firstTrailer
                              ? true
                              : row.useType === 2 && row.firstEpisode
                          "
                          style="
                            text-decoration: underline;
                            color: #3370ff;
                            cursor: pointer;
                          "
                          @click="handleMediaSelectPreview(row)"
                          >&nbsp;预览</span
                        >
                      </div>
                      <div v-else-if="row.mySelect && row.mySave">
                        <span>{{
                          row.useType === 1
                            ? "片花"
                            : row.useType === 2
                            ? "分集"
                            : ""
                        }}</span>
                        <span>{{
                          row.useType === 1
                            ? `(${row.trailerId ? row.trailerId : ""})`
                            : row.useType === 2
                            ? `(${row.episodeId ? row.episodeId : ""})`
                            : ""
                        }}</span>
                        <span
                          v-if="
                            row.useType === 1 && row.trailerId
                              ? true
                              : row.useType === 2 && row.episodeId
                          "
                          style="
                            text-decoration: underline;
                            color: #3370ff;
                            cursor: pointer;
                          "
                          @click="handleMediaSelectPreview(row)"
                          >&nbsp;预览</span
                        >
                      </div>
                    </template>
                    <template #sortOption="scope">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <el-button
                          type="text"
                          size="small"
                          @click="sortPrev(scope.row)"
                          >上移</el-button
                        >
                        <el-button
                          type="text"
                          size="small"
                          @click="sortNext(scope.row)"
                          >下移</el-button
                        >
                        <el-button
                          type="text"
                          size="small"
                          @click="sortTop(scope.row)"
                          >置顶</el-button
                        >
                      </div>
                    </template>
                    <!-- 自定义表格操作栏 -->
                    <template #menu="scope">
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <span v-if="false">{{ scope }}</span>
                        <el-button
                          type="text"
                          @click="handleMediaEdit(scope.row)"
                          >编辑</el-button
                        >
                        <el-button
                          type="text"
                          @click="handleMediaDel(scope.row)"
                          >移出</el-button
                        >
                      </div>
                    </template>
                  </avue-crud>
                  <ElementPagination
                    style="margin-bottom: 20px"
                    :current-page="mediaSelectParams.current"
                    :page-size="mediaSelectParams.size"
                    :total="mediaSelectParams.total"
                    :page-sizes="[10, 20, 30, 40, 50, 100]"
                    @size-change="handleMediaSelectSizeChange"
                    @current-change="handleMediaSelectCurrentChange"
                  />
                </div>
              </el-form-item>
            </div>
          </el-collapse-item>
          <el-collapse-item name="3">
            <template slot="title">
              <h3 class="add-title">续播频控配置</h3>
            </template>
            <div class="add-item">
              <el-form-item
                label-width="150px"
                prop="dayLimit"
                label="媒资单日有效播放："
              >
                <el-input
                  v-model="addForm.dayLimit"
                  style="width: 15vw"
                  placeholder="输入正整数"
                ></el-input
                ><span class="tips">&nbsp;&nbsp;次/设备</span>
              </el-form-item>
              <el-form-item
                prop="totalLimit"
                style="margin-top: 15px"
                label-width="150px"
                label="媒资总有效播放："
              >
                <el-input
                  v-model="addForm.totalLimit"
                  style="width: 15vw"
                  placeholder="输入正整数"
                ></el-input
                ><span class="tips2">&nbsp;&nbsp;次/设备</span>
              </el-form-item>
            </div>
          </el-collapse-item>
          <el-collapse-item name="4">
            <template slot="title">
              <h3 class="add-title">展示配置</h3>
            </template>
            <div style="display: flex; flex-direction: column" class="add-item">
              <el-form-item prop="imgType" label="图片样式：">
                <!-- 单选radio 选项1 横图样式 选项2 竖图样式 -->
                <el-radio-group v-model="addForm.imgType">
                  <el-radio :label="1">横图样式</el-radio>
                  <el-radio :label="2">竖图样式</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="isIntervene" label="排序人工干预：">
                <el-radio-group v-model="addForm.isIntervene">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="addForm.isIntervene === 1"
                prop="interveneQuantity"
                label="干预数量："
              >
                <el-input
                  v-model="addForm.interveneQuantity"
                  placeholder="输入正整数"
                ></el-input>
              </el-form-item>
              <el-form-item v-if="addForm.isIntervene === 1" label=" ">
                <span style="color: gray; font-size: 12px"
                  >干预数量X，代表1~X
                  人工排序生效，X之后列表随机排序，0代表全随机</span
                >
              </el-form-item>
            </div>
          </el-collapse-item>
        </el-collapse>
        <el-form-item
          style="padding: 1% 0 5% 5%"
          label-width="130px"
          prop="status"
          label="策略状态："
        >
          <el-radio-group v-model="addForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="confirmSave">保 存</el-button>
        <el-button @click="closeAddDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //^ ^--------------媒资选择对话框-------------^ ^ -->
    <el-dialog
      title="媒资选择"
      append-to-body
      :visible.sync="mediaSelectVisible"
      width="60%"
      @closed="closeSelectDialog"
    >
      <div class="search-contain">
        <div class="search-left">
          <el-input
            v-model="mediaSearchParams.search"
            clearable
            style="width: 70%"
            placeholder="乐播媒资ID/三方媒资ID/媒资名称"
          ></el-input>
          <!-- <el-input clearable style="width: 40%;margin-left: 20px;" placeholder="三方媒资ID"></el-input>
          <el-input clearable style="width: 40%;margin-left: 20px;" placeholder="媒资名称"></el-input> -->
          <el-select
            v-model="mediaSearchParams.type"
            style="width: 40%; margin-left: 20px"
            clearable
            placeholder="媒资类型"
          >
            <!-- 0其它 1电影 2电视剧 3动画片 4短剧 5电影票 6团购券-->
            <el-option label="电影" value="1"></el-option>
            <el-option label="电视剧" value="2"></el-option>
            <el-option label="动画片" value="3"></el-option>
            <el-option label="短剧" value="4"></el-option>
            <el-option label="电影票" value="5"></el-option>
            <el-option label="团购券" value="6"></el-option>
            <el-option label="其它" value="0"></el-option>
          </el-select>
        </div>
        <div class="search-right">
          <el-button
            style="margin-left: 10px"
            type="primary"
            size="small"
            @click="mediaSearch"
            >搜索</el-button
          >
        </div>
      </div>
      <el-table
        row-key="id"
        ref="mediaTable"
        style="margin-top: 20px"
        :data="mediaTable"
        border
        stripe
        @select="handleSelectionChange"
        @select-all="selectAll"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          prop="renderMediaId"
          label="乐播媒资ID"
        ></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="媒资名称">
          <template slot-scope="scope">
            <div style="color: blue">{{ scope.row.name }}</div>
            <!-- <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
              <div style="color: blue;">{{ scope.row.name }}</div>
            </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column prop="mediaType" label="媒资类型">
          <template slot-scope="scope">
            <!-- 0其它 1电影 2电视剧 3动画片 4短剧 5电影票 6团购券 -->
            <span>{{
              scope.row.type === 0
                ? "其他"
                : scope.row.type === 1
                ? "电影"
                : scope.row.type === 2
                ? "电视剧"
                : scope.row.type === 3
                ? "动画片"
                : scope.row.type === 4
                ? "短剧"
                : scope.row.type === 5
                ? "电影票"
                : scope.row.type === 6
                ? "团购券"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="horizontalImg" label="横图">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.horizontalImgLarge"
              :src="scope.row.horizontalImgLarge"
              :previewSrcList="[scope.row.horizontalImgLarge]"
              alt=""
            />
            <el-image
              v-else-if="scope.row.horizontalImgSmall"
              :src="scope.row.horizontalImgSmall"
              :previewSrcList="[scope.row.horizontalImgSmall]"
              alt=""
            />
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="partnerName" label="来源"></el-table-column>
        <el-table-column width="100" prop="" label="展示选择">
          <template slot-scope="{row}">
            <span>{{ row.type === 1 ? "片花" : row.type === 4 ? '分集' : '' }}</span>
            <span>{{ row.type === 1 ? `(${row.firstTrailer.id ? row.firstTrailer.id : ''})` : row.type === 4 ?
              `(${row.firstEpisode.id ? row.firstEpisode.id : ''})` :
              '' }}</span>
            <span v-if="row.type === 1 && row.firstTrailer.id ? true : row.type === 4 && row.firstEpisode.id"
              style="text-decoration: underline;color: #3370ff;cursor: pointer;"
              @click="handleMediaSelectPreview(row)">&nbsp;预览</span>
          </template>

        </el-table-column> -->
        <el-table-column prop="status" label="媒资状态">
          <template slot-scope="scope">
            <span :class="{ 'green-text': scope.row.status === 1 }">{{
              scope.row.status === 1 ? "上线" : "下线"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="180"
          prop="updateTime"
          label="更新时间"
        ></el-table-column>
      </el-table>
      <ElementPagination
        style="margin-bottom: 20px"
        :current-page="mediaSearchParams.current"
        :page-size="mediaSearchParams.size"
        :total="mediaSearchParams.total"
        :page-sizes="[10, 20, 30, 40, 50]"
        @size-change="mediaSizeChange"
        @current-change="mediaCurrentChange"
      />

      <el-popover placement="top" title="" width="400" trigger="click">
        <div>已选记录列表</div>
        <div>
          已选择 ({{ selectNum }})
          <span style="cursor: pointer; color: #3370ff" @click="selectedDel('')"
            >全部移除</span
          >
        </div>
        <el-table max-height="500" :data="selectList">
          <el-table-column
            width="150"
            prop="renderMediaId"
            label="乐播媒资ID"
          ></el-table-column>
          <el-table-column
            width="100"
            prop="name"
            label="媒资名称"
          ></el-table-column>
          <el-table-column width="100" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="selectedDel(scope.row)"
                >移出</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div slot="reference" style="width: 80px; cursor: pointer">
          <span
            >已选择&nbsp;&nbsp;<span style="color: #3370ff; cursor: pointer"
              >({{ selectNum }})</span
            ></span
          >
        </div>
      </el-popover>

      <span slot="footer">
        <el-button type="primary" @click="mediaIdSelectOk">确 定</el-button>
        <el-button @click="closeSelectDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //^ ^--------------媒资编辑的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="mediaEditDialog"
      title="媒资编辑"
      append-to-body
      :modal-append-to-body="false"
      width="50%"
      @closed="mediaEditClose"
    >
      <div class="">
        <el-form
          style="margin-left: 20px"
          :model="mediaEditData"
          ref="mediaEditForm"
          :rules="mediaEditFormRules"
          inline
          label-position="left"
          label-width="130px"
        >
          <div style="display: flex">
            <div style="flex: 1">
              <el-form-item label="媒资名称：">
                {{ mediaEditData.media.name }}
              </el-form-item>
              <el-form-item label="横图：">
                <el-image
                  v-if="mediaEditData.media.horizontalImg"
                  style="width: 150px; height: 100px"
                  :src="mediaEditData.media.horizontalImg"
                  :preview-src-list="[mediaEditData.media.horizontalImg]"
                  alt=""
                ></el-image>
                <span v-else>暂无图片</span>
              </el-form-item>
              <el-form-item label="展示选择：">
                <!-- 单选 radio 选项1 分集 选项2 片花 -->
                <el-radio-group v-model="mediaEditData.useType">
                  <el-radio :label="2">分集</el-radio>
                  <el-radio :label="1">片花</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div style="flex: 1; display: flex; flex-direction: column">
              <el-form-item label="媒资类型：">
                <!-- 0其它 1电影 2电视剧 3动画片 4短剧 5电影票 6团购券 -->
                <span>{{
                  mediaEditData.media.type === 0
                    ? "其他"
                    : mediaEditData.media.type === 1
                    ? "电影"
                    : mediaEditData.media.type === 2
                    ? "电视剧"
                    : mediaEditData.media.type === 3
                    ? "动画片"
                    : mediaEditData.media.type === 4
                    ? "短剧"
                    : mediaEditData.media.type === 5
                    ? "电影票"
                    : mediaEditData.media.type === 6
                    ? "团购券"
                    : ""
                }}</span>
              </el-form-item>
              <el-form-item label="竖图：">
                <el-image
                  v-if="mediaEditData.media.verticalImg"
                  style="width: 100px; height: 100px"
                  :src="mediaEditData.media.verticalImg"
                  :preview-src-list="[mediaEditData.media.verticalImg]"
                  alt=""
                ></el-image>
                <span v-else>暂无图片</span>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex; flex-direction: column">
            <!-- 选择片花 -->
            <el-form-item v-if="mediaEditData.useType === 1" label="片花选择：">
              <el-button
                style="width: 100px"
                size="small"
                @click="handleTrailerSelect"
                >选择</el-button
              >
            </el-form-item>
            <el-form-item label=" ">
              <span
                v-if="mediaEditData.useType === 1 && mediaEditData.trailer.id"
              >
                {{
                  mediaEditData.trailer.name + `(${mediaEditData.trailer.id})`
                }}</span
              >
              <span
                v-if="mediaEditData.useType === 1 && mediaEditData.trailer.id"
                style="color: #3370ff; cursor: pointer"
                @click="handleMediaEditPreview(mediaEditData)"
                >&nbsp;&nbsp;&nbsp;预览</span
              >
            </el-form-item>
            <!-- 选择分集 -->
            <el-form-item v-if="mediaEditData.useType === 2" label="分集选择：">
              <el-button
                style="width: 100px"
                size="small"
                @click="handleDiversitySelect"
                >选择</el-button
              >
            </el-form-item>
            <el-form-item label=" ">
              <span
                v-if="mediaEditData.useType === 2 && mediaEditData.episode.id"
              >
                {{
                  mediaEditData.episode.name + `(${mediaEditData.episode.id})`
                }}</span
              >
              <span
                v-if="mediaEditData.useType === 2 && mediaEditData.episode.id"
                style="color: #3370ff; cursor: pointer"
                @click="handleMediaEditPreview(mediaEditData)"
                >&nbsp;&nbsp;&nbsp;预览</span
              >
            </el-form-item>
            <el-form-item label="生效时间：">
              <!-- 多选框组 1-总时段生效 2-单日时段生效 -->
              <el-checkbox-group v-model="mediaEditData.timeWay">
                <el-checkbox label="1">总时段生效</el-checkbox>
                <el-checkbox label="2">单日时段生效</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              v-if="mediaEditData.timeWay.includes('1')"
              label="总时段："
            >
              <!-- 两个时间选择器(精确到年月日) 开始时间-结束时间 -->
              <div style="display: flex">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <el-date-picker
                    ref="startDatePicker"
                    v-model="mediaEditData.validStartDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker
                  ><span>开始时间</span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-left: 10px;
                  "
                >
                  <el-date-picker
                    ref="endDatePicker"
                    :picker-options="endPickerOptions"
                    v-model="mediaEditData.validEndDate"
                    type="date"
                    placeholder="选择日期"
                  >
                  </el-date-picker
                  ><span>结束时间</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              v-if="mediaEditData.timeWay.includes('2')"
              label="单日时段："
            >
              <!-- 两个时间选择器(精确到) 开始时间-结束时间 -->
              <div style="display: flex">
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <el-time-picker
                    format="HH:mm:ss"
                    v-model="mediaEditData.validStartTime"
                    placeholder="选择日期"
                  >
                  </el-time-picker
                  ><span>开始时间</span>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    margin-left: 10px;
                  "
                >
                  <el-time-picker
                    format="HH:mm:ss"
                    v-model="mediaEditData.validEndTime"
                    :picker-options="endSinglePickerOptions"
                    placeholder="选择日期"
                  >
                  </el-time-picker
                  ><span>结束时间</span>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <span
          style="display: flex; flex-direction: row; justify-content: end"
          slot="footer"
        >
          <el-button type="primary" @click="confirmMediaEdit">保 存</el-button>
          <el-button @click="mediaEditClose">取 消</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- //^ ^--------------三方分集的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="partnerDiversityDialog"
      title="三方分集信息"
      append-to-body
      :modal-append-to-body="false"
    >
      <el-form
        :model="partnerDiversityData"
        label-position="left"
        label-width="130px"
      >
        <div style="padding: 0 40px; display: flex; flex-direction: row">
          <div style="flex: 1">
            <el-form-item label="三方分集ID：">
              {{
                diversityDetailData.episodePartnerData.id
                  ? diversityDetailData.episodePartnerData.id
                  : "-"
              }}
            </el-form-item>
            <el-form-item label="版权商分集ID ：">
              {{
                diversityDetailData.episodePartnerData.copyrightEpisodeId
                  ? diversityDetailData.episodePartnerData.copyrightEpisodeId
                  : "-"
              }}
            </el-form-item>
          </div>
          <div style="flex: 1">
            <el-form-item label="三方分集状态：">
              {{
                diversityDetailData.episodePartnerData.partnerEpisodeStatus ===
                1
                  ? "已上架"
                  : "已下架"
              }}
            </el-form-item>
            <el-form-item label="版权商分集编号：">
              {{
                diversityDetailData.episodePartnerData.copyrightEpisodeCode
                  ? diversityDetailData.episodePartnerData.copyrightEpisodeCode
                  : "-"
              }}
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- //^ ^--------------三方片花的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="partnerTrailerDialog"
      title="三方片花信息"
      append-to-body
      :modal-append-to-body="false"
    >
      <el-form
        :model="partnerTrailerData"
        label-position="left"
        label-width="130px"
      >
        <div style="padding: 0 40px; display: flex; flex-direction: row">
          <div style="flex: 1">
            <el-form-item label="三方片花ID：">
              {{
                trailerDetailData.trailerPartnerData.partnerTrailerId
                  ? trailerDetailData.trailerPartnerData.partnerTrailerId
                  : "-"
              }}
            </el-form-item>
            <el-form-item label="版权商片花ID ：">
              {{
                trailerDetailData.trailerPartnerData.copyrightTrailerId
                  ? trailerDetailData.trailerPartnerData.copyrightTrailerId
                  : "-"
              }}
            </el-form-item>
          </div>
          <div style="flex: 1">
            <el-form-item label="三方片花状态：">
              {{
                trailerDetailData.trailerPartnerData.partnerTrailerStatus === 1
                  ? "已上架"
                  : "已下架"
              }}
            </el-form-item>
            <el-form-item label="版权商片花编号：">
              {{
                trailerDetailData.trailerPartnerData.copyrightTrailerCode
                  ? trailerDetailData.trailerPartnerData.copyrightTrailerCode
                  : "-"
              }}
            </el-form-item>
          </div>
        </div>
      </el-form>
    </el-dialog>
    <!-- //^ ^--------------片花选择的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="trailerSelectDialog"
      title="片花选择"
      append-to-body
      :modal-append-to-body="false"
      @closed="trailerSelectCancel"
    >
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input
            style="margin-right: 10px; width: 150px"
            size="small"
            placeholder="片花ID"
            clearable
            v-model="trailerId"
          ></el-input>
          <!-- <el-input style="width: 150px;" size="small" placeholder="分集名称" clearable v-model="diversityName"></el-input> -->
        </div>
        <div>
          <el-button size="small" type="primary" @click="trailerSearch"
            >搜索</el-button
          >
        </div>
      </div>
      <!-- 片花选择的table 第一列是radio  -->
      <el-table style="margin-top: 20px" :data="trailerTable" border stripe>
        <el-table-column label="">
          <template slot-scope="scope">
            <el-radio
              v-model="trailerRadioId"
              :label="scope.row.id"
              @change="handleTrailerRadioChange(scope.row)"
              >{{ trailerSpace }}</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="id" label="片花ID"></el-table-column>
        <el-table-column prop="mediaName" label="对应分集"></el-table-column>
        <el-table-column prop="type" label="类型">
          <!-- 0其它 1片花/花絮 2预告片 3高能看点 4二次创作 5一般关系 -->
          <template slot-scope="scope">
            <span v-if="scope.row.type === 0">其它</span>
            <span v-else-if="scope.row.type === 1">片花/花絮</span>
            <span v-else-if="scope.row.type === 2">预告片</span>
            <span v-else-if="scope.row.type === 3">高能看点</span>
            <span v-else-if="scope.row.type === 4">二次创作</span>
            <span v-else-if="scope.row.type === 5">一般关系</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="封面">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.horizontalImg"
              :src="scope.row.horizontalImg"
              :previewSrcList="[scope.row.horizontalImg]"
              alt=""
            />
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="时长">
          <template slot-scope="scope">
            <span>{{
              scope.row.duration | secondsToStandardization(scope.row.duration)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span>{{ scope.row.status === 1 ? "上线" : "下线" }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleTrailerPreview(scope.row)"
              >预览</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleTrailerDetail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 确认和保存 -->
      <span slot="footer">
        <el-button type="primary" @click="trailerSelectOk">确 定</el-button>
        <el-button @click="trailerSelectCancel">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //^ ^--------------分集选择的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="diversitySelectDialog"
      title="分集选择"
      append-to-body
      :modal-append-to-body="false"
      @closed="diversitySelectCancel"
    >
      <div style="display: flex; justify-content: space-between">
        <div style="display: flex">
          <el-input
            style="margin-right: 10px; width: 150px"
            size="small"
            placeholder="分集ID"
            clearable
            v-model="diversityId"
          ></el-input>
          <el-input
            style="width: 150px"
            size="small"
            placeholder="分集名称"
            clearable
            v-model="diversityName"
          ></el-input>
        </div>
        <div>
          <el-button size="small" type="primary" @click="diversitySearch"
            >搜索</el-button
          >
        </div>
      </div>
      <!-- 分集选择的table 第一列是radio  -->
      <el-table style="margin-top: 20px" :data="diversityTable" border stripe>
        <el-table-column label="">
          <template slot-scope="scope">
            <el-radio
              v-model="diversityRadioId"
              :label="scope.row.id"
              @change="handleDiversityRadioChange(scope.row)"
              >{{ diversitySpace }}</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="id" label="分集ID"></el-table-column>
        <el-table-column prop="num" label="分集序号"></el-table-column>
        <el-table-column prop="name" label="分集名称"></el-table-column>
        <el-table-column prop="feeMode" label="解锁">
          <template slot-scope="scope">
            <span>{{
              scope.row.episodeMovie.feeMode === 0
                ? "是"
                : scope.row.episodeMovie.feeMode === 2
                ? "否"
                : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="horizontalImg" label="封面">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.horizontalImg"
              :src="scope.row.horizontalImg"
              :previewSrcList="[scope.row.horizontalImg]"
              alt=""
            />
            <span v-else>暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="状态"></el-table-column>
        <el-table-column prop="updateTime" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleDiversityPreview(scope.row)"
              >预览</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleDiversityDetail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 确认和保存 -->
      <span slot="footer">
        <el-button type="primary" @click="diversitySelectOk">确 定</el-button>
        <el-button @click="diversitySelectCancel">取 消</el-button>
      </span>
    </el-dialog>
    <!-- //^ ^--------------分集详情的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="diversityDetailDialog"
      title="分集详情"
      append-to-body
      :modal-append-to-body="false"
      @closed="diversityCloseCancel"
    >
      <el-form
        :model="diversityDetailData"
        label-position="left"
        label-width="130px"
      >
        <div
          style="
            padding: 0 40px;
            display: flex;
            flex-direction: row;
            background-color: #f7f7f7;
          "
        >
          <div style="flex: 1">
            <el-form-item label="乐播分集ID：">
              {{ diversityDetailData.id }}
            </el-form-item>
            <el-form-item label="分集名称：">
              {{ diversityDetailData.name ? diversityDetailData.name : "-" }}
            </el-form-item>
            <el-form-item label="横图：">
              <el-image
                v-if="diversityDetailData.horizontalImg"
                style="width: 150px; height: 100px"
                :src="diversityDetailData.horizontalImg"
                :preview-src-list="[diversityDetailData.horizontalImg]"
                alt=""
              ></el-image>
              <span v-else>暂无图片</span>
            </el-form-item>
            <el-form-item label="时长：">
              {{
                diversityDetailData.duration
                  | secondsToStandardization(diversityDetailData.duration)
              }}
            </el-form-item>
            <el-form-item label="是否付费：">
              {{ diversityDetailData.feeMode === 0 ? "否" : "是" }}
            </el-form-item>
            <el-form-item label="播放链接">
              {{ diversityDetailData.playUrl
              }}<span
                style="color: #15a2f2; cursor: pointer"
                @click="
                  () => {
                    videoUrl = diversityDetailData.playUrl;
                    videoDialogVisible = true;
                  }
                "
                >&nbsp;&nbsp;预览</span
              >
            </el-form-item>
          </div>
          <div style="flex: 1">
            <el-form-item label="分集序号：">
              {{ diversityDetailData.num ? diversityDetailData.num : "-" }}
            </el-form-item>
            <el-form-item label="分集描述：">
              {{ diversityDetailData.aword ? diversityDetailData.aword : "-" }}
            </el-form-item>
            <el-form-item label="竖图：">
              <el-image
                v-if="diversityDetailData.verticalImg"
                style="width: 100px; height: 100px"
                :src="diversityDetailData.verticalImg"
                :preview-src-list="[diversityDetailData.verticalImg]"
                alt=""
              ></el-image>
              <span v-else>暂无图片</span>
            </el-form-item>
            <el-form-item label="试看时长：">
              {{
                diversityDetailData.episodeMovie.trialDuration
                  | secondsToStandardization(
                    diversityDetailData.episodeMovie.trialDuration
                  )
              }}
            </el-form-item>
            <el-form-item label="视频样式：">
              {{
                diversityDetailData.direction === 1
                  ? "横视频"
                  : diversityDetailData.direction === 2
                  ? "竖视频"
                  : "-"
              }}
            </el-form-item>
            <el-form-item label="二维码地址：">
              {{
                diversityDetailData.qrCode ? diversityDetailData.qrCode : "-"
              }}
            </el-form-item>
          </div>
        </div>
        <div
          style="padding: 0 40px; display: flex; justify-content: space-between"
        >
          <el-form-item label="分集状态：">
            <span :class="{ 'green-text': diversityDetailData.status === 1 }">{{
              diversityDetailData.status === 0 ? "下线" : "上线"
            }}</span>
          </el-form-item>
          <el-form-item label=" ">
            <span
              style="
                text-decoration: underline;
                color: #15a2f2;
                cursor: pointer;
              "
              @click="handlePartnerDiversity"
              >三方分集信息</span
            >
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- //^ ^--------------片花详情的对话框-------------^ ^ -->
    <el-dialog
      :visible.sync="trailerDetailDialog"
      title="片花详情"
      append-to-body
      :modal-append-to-body="false"
      @closed="trailerCloseCancel"
    >
      <el-form
        :model="trailerDetailData"
        label-position="left"
        label-width="130px"
      >
        <div
          style="
            padding: 0 40px;
            display: flex;
            flex-direction: row;
            background-color: #f7f7f7;
          "
        >
          <div style="flex: 1">
            <el-form-item label="乐播片花ID：">
              {{ trailerDetailData.id ? trailerDetailData.id : "-" }}
            </el-form-item>
            <el-form-item label="片花名称：">
              {{ trailerDetailData.aword ? trailerDetailData.aword : "-" }}
            </el-form-item>
            <el-form-item label="对应分集：">
              {{
                trailerDetailData.episodeName
                  ? trailerDetailData.episodeName
                  : "-"
              }}
            </el-form-item>
            <el-form-item label="横图：">
              <el-image
                v-if="trailerDetailData.horizontalImg"
                style="width: 150px; height: 100px"
                :src="trailerDetailData.horizontalImg"
                :preview-src-list="[trailerDetailData.horizontalImg]"
                alt=""
              ></el-image>
              <span v-else>暂无图片</span>
            </el-form-item>
            <el-form-item label="视频样式：">
              {{
                trailerDetailData.direction === 1
                  ? "横视频"
                  : trailerDetailData.direction === 2
                  ? "竖视频"
                  : "-"
              }}
            </el-form-item>
          </div>
          <div style="flex: 1">
            <el-form-item label="对应剧片：">
              {{
                trailerDetailData.mediaName ? trailerDetailData.mediaName : "-"
              }}
            </el-form-item>
            <el-form-item label="类型：">
              <!-- type	类型：0其它 1片花/花絮 2预告片 3高能看点 4二次创作 5一般关系 -->
              <span v-if="trailerDetailData.type === 0">其它</span>
              <span v-else-if="trailerDetailData.type === 1">片花/花絮</span>
              <span v-else-if="trailerDetailData.type === 2">预告片</span>
              <span v-else-if="trailerDetailData.type === 3">高能看点</span>
              <span v-else-if="trailerDetailData.type === 4">二次创作</span>
              <span v-else-if="trailerDetailData.type === 5">一般关系</span>
            </el-form-item>
            <el-form-item label="时长：">
              {{
                trailerDetailData.duration
                  | secondsToStandardization(trailerDetailData.duration)
              }}
            </el-form-item>
            <el-form-item label="竖图：">
              <el-image
                v-if="trailerDetailData.verticalImg"
                style="width: 100px; height: 100px"
                :src="trailerDetailData.verticalImg"
                :preview-src-list="[trailerDetailData.verticalImg]"
                alt=""
              ></el-image>
              <span v-else>暂无图片</span>
            </el-form-item>
            <el-form-item label="播放链接：">
              {{ trailerDetailData.playUrl }}
              <span
                style="color: #15a2f2; cursor: pointer"
                @click="
                  () => {
                    videoUrl = trailerDetailData.playUrl;
                    videoDialogVisible = true;
                  }
                "
                >&nbsp;&nbsp;预览</span
              >
            </el-form-item>
          </div>
        </div>
        <div
          style="padding: 0 40px; display: flex; justify-content: space-between"
        >
          <el-form-item label="片花状态：">
            <span :class="{ 'green-text': trailerDetailData.status === 1 }">{{
              trailerDetailData.status === 1 ? "上线" : "下线"
            }}</span>
          </el-form-item>
          <el-form-item label=" ">
            <span
              style="
                text-decoration: underline;
                color: #15a2f2;
                cursor: pointer;
              "
              @click="handlePartnerTrailer"
              >三方片花信息</span
            >
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- //^ ^--------------预览视频的弹窗-------------^ ^ -->
    <VideoDialog
      :videoDialogVisible.sync="videoDialogVisible"
      :videoUrl="videoUrl"
    ></VideoDialog>
  </div>
</template>

<script>
import moment from "moment";
import ElementPagination from "@/components/ElementPagination";
import {
  getList,
  getMediaList,
  add,
  getDetail,
  edit,
  del,
  getMediaDetail,
  getMediaInfo,
  getMediaSource,
} from "@/api/mediaManage/recommendStrategy.js";
import Message from "@/components/Message";
import options from "./option";
import dragOption from "./dragOption";
import VideoDialog from "./components/video.vue";
import { merge } from "lodash";
export default {
  name: "WebOpenPlatformIndex",
  components: {
    ElementPagination,
    VideoDialog,
  },
  watch: {
    addForm: {
      handler: function (newV, oldV) {
        console.log("newValue", newV);
        console.log("oldValue", oldV);
      },
      deep: true,
    },
  },
  data() {
    return {
      /** 媒资选择静态列表 */
      mediaSelectLocalList: [],
      /** 媒资来源list */
      mediaSourceList: [],
      /** 媒资选择的搜索参数 */
      mediaSelectParams: {
        current: 1,
        size: 10,
        total: 50,
        type: "",
        source: "",
        name: "",
      },
      /** 三方片花的对话框 */
      partnerTrailerDialog: false,
      /** 三方分集的对话框 */
      partnerDiversityDialog: false,
      /** 三方分集的信息 */
      partnerDiversityData: {},
      /** 片花详情内的数据 */
      trailerDetailData: {
        id: "",
        aword: "",
        mediaName: "",
        type: "",
        horizontalImg: "",
        verticalImg: "",
        status: "",
        playUrl: "",
        direction: "",
        duration: "",
        trailerPartnerData: {
          partnerTrailerId: "",
          partnerTrailerStatus: "",
          copyrightTrailerCode: "",
          copyrightTrailerId: "",
        },
      },
      /** 分集详情内的数据 */
      diversityDetailData: {
        id: "",
        num: "",
        name: "",
        horizontalImg: "",
        verticalImg: "",
        feeMode: "",
        episodePartnerData: {
          id: "",
          partnerEpisodeStatus: "",
          copyrightEpisodeId: "",
          copyrightEpisodeCode: "",
        },
        /** 只有分集才有试看时长 */
        episodeMovie: {
          trialDuration: "",
        },
      },
      /** 分集详情的对话框 */
      diversityDetailDialog: false,
      /** 片花详情的对话框 */
      trailerDetailDialog: false,
      /** 媒资编辑的数据 */
      mediaEditData: {
        episodeList: [],
        selectTrailer: {
          id: "",
          name: "",
          playUrl: "",
        },
        trailer: {
          id: "",
          name: "",
          playUrl: "",
        },
        selectEpisode: {
          id: "",
          name: "",
          playUrl: "",
        },
        episode: {
          id: "",
          name: "",
          playUrl: "",
        },
        /** 展示选择 */
        useType: "",
        /** 生效方式 */
        timeWay: [],
        /** 有效开始日期 */
        validStartDate: "",
        /** 有效结束日期 */
        validEndDate: "",
        /** 有效开始时间 */
        validStartTime: "",
        /** 有效结束时间 */
        validEndTime: "",
        media: {
          name: "",
          horizontalImg: "",
          verticalImg: "",
          type: "",
          status: "",
          partnerStatus: "",
          updateTime: "",
        },
      },
      /** 总时段结束时间 */
      endPickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() <
            new Date(this.mediaEditData.validStartDate).getTime()
          );
        },
      },
      /** 分集单选的空白 */
      diversitySpace: "",
      /** 分集单选id */
      diversityRadioId: "",
      /** 分集单选真正的id */
      diversityRadioTrueId: "",
      /** 分集选择列表里的数据 */
      diversityTable: [],
      /** 分集Id */
      diversityId: "",
      /** 分集名称 */
      diversityName: "",
      /** 分集选择的对话框 */
      diversitySelectDialog: false,
      /** 片花选择的对话框 */
      trailerSelectDialog: false,
      /** 片花Id */
      trailerId: "",
      /** 片花单选的空白 */
      trailerSpace: "",
      /** 片花单选id */
      trailerRadioId: "",
      /** 片花单选真正的id */
      trailerRadioTrueId: "",
      /** 片花选择列表里的数据 */
      trailerTable: [],
      /** 媒资选择对话框的显隐 */
      mediaEditDialog: false,
      /** 已选择的表格数据 */
      selectList: [],
      /** 已选择媒资的个数 */
      selectNum: "",
      /** 预览视频的url */
      videoUrl:
        "https://lebotob.hpplay.cn/upload/20230914/2627ab6e57ef146e06674438279c8289.mp4",
      /** 预览视频的弹窗 */
      videoDialogVisible: false,
      dragOption: dragOption(this),
      /** 是否是编辑 */
      isEdit: false,
      /** 媒资选择列表搜索参数 */
      mediaSearchParams: {
        current: 1,
        size: 10,
        total: 50,
        type: "",
        search: "",
        status: 1,
      },
      /** 搜索参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: 50,
        search: "",
        status: "",
      },
      //^ ^--------------媒资选择框内的数据-------------^ ^
      /** 媒资选择框的显隐 */
      mediaSelectVisible: false,
      /** 媒资表格数据 */
      mediaTable: [],
      /** 选择的媒资数据 */
      mediaSelectList: [],
      //^ ^--------------新增/编辑对话框里的数据-------------^ ^
      /** 折叠面板 */
      activeNames: ["1", "2", "3", "4"],
      /** 新增/编辑的表单数据 */
      addForm: {
        name: "",
        descr: "",
        tacticsMedias: [],
        status: "",
        dayLimit: "",
        totalLimit: "",
        /** 图片类型 1横图 2竖图 */
        imgType: 1,
        /** 是否人工干预 */
        isIntervene: 0,
        /** 干预数量 */
        interveneQuantity: "",
      },
      /** 新增/编辑表单的验证规则 */
      addFormRules: {
        name: [
          { required: true, message: "请输入策略名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 999 个字符",
            trigger: "blur",
          },
        ],
        scene: [
          { required: true, message: "请选择策略场景", trigger: "change" },
        ],
        tacticsMedias: [
          {
            required: true,
            message: "请选择媒资",
            trigger: "change",
            type: "array",
          },
        ],
        status: [
          { required: true, message: "请选择策略状态", trigger: "change" },
        ],
        dayLimit: [
          // 非必填而且必须是正整数
          {
            required: false,
            pattern: /^(0|[1-9]\d*)$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
        totalLimit: [
          // 非必填而且必须是正整数 可以填0
          {
            required: false,
            pattern: /^(0|[1-9]\d*)$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
        interveneQuantity: [
          // 非必填而且必须是正整数 可以填0
          {
            required: false,
            pattern: /^(0|[1-9]\d*)$/,
            message: "请输入正整数",
            trigger: "blur",
          },
        ],
      },
      /** 新增/编辑对话框的显隐 */
      addVisible: false,
      //^ ^-------------新增/编辑对话框里的数据-end--------------^ ^
      option: options(this),
      /** avue表格里的数据 */
      list: [],
    };
  },
  created() {
    this.loadList();
    this.getMediaList();
    this.loadMediaSource();
  },
  methods: {
    /** 媒资配置-重置 */
    mediaConfReset() {
      this.mediaSelectParams.name = "";
      this.mediaSelectParams.type = "";
      this.mediaSelectParams.source = "";
    },
    /** 媒资配置 - 静态搜索*/
    mediaConfSearch() {
      /** 静态搜索 */
      this.mediaSelectParams.current = 1;
      this.addForm.tacticsMedias = this.mediaSelectLocalList.filter((item) => {
        const isNameMatch =
          !this.mediaSelectParams.name ||
          item.name.includes(this.mediaSelectParams.name);
        const isTypeMatch =
          !this.mediaSelectParams.type ||
          item.type === this.mediaSelectParams.type;
        const isSourceMatch =
          !this.mediaSelectParams.source ||
          item.partnerName === this.mediaSelectParams.source;

        return isNameMatch && isTypeMatch && isSourceMatch;
      });
      this.mediaSelectParams.total = this.addForm.tacticsMedias.length;

      Message.success("搜索成功");
    },
    /** 媒资配置-媒资选择列表-置顶 */
    sortTop(row) {
      console.log("置顶", row);
      const index = this.addForm.tacticsMedias.findIndex(
        (item) => item.id === row.id
      );
      if (index === 0) {
        Message.error("已经是第一个了");
        return;
      }
      const top = this.addForm.tacticsMedias[0];
      this.$set(this.addForm.tacticsMedias, 0, row);
      this.$set(this.addForm.tacticsMedias, index, top);
    },
    /** 媒资配置-媒资选择列表-下移 */
    sortNext(row) {
      console.log("下移", row);
      const index = this.addForm.tacticsMedias.findIndex(
        (item) => item.id === row.id
      );
      if (index === this.addForm.tacticsMedias.length - 1) {
        Message.error("已经是最后一个了");
        return;
      }
      const next = this.addForm.tacticsMedias[index + 1];
      if (next) {
        this.$set(this.addForm.tacticsMedias, index + 1, row);
        this.$set(this.addForm.tacticsMedias, index, next);
      }
    },
    /** 媒资配置-媒资选择列表-上移 */
    sortPrev(row) {
      console.log("上移", row);
      const index = this.addForm.tacticsMedias.findIndex(
        (item) => item.id === row.id
      );
      if (index === 0) {
        Message.error("已经是第一个了");
        return;
      }
      const prev = this.addForm.tacticsMedias[index - 1];
      if (prev) {
        this.$set(this.addForm.tacticsMedias, index - 1, row);
        this.$set(this.addForm.tacticsMedias, index, prev);
      }
    },
    /** 预览弹窗的方法 */
    handleAlertPreview(url) {
      let _dom = "video controls";
      this.$alert(
        `<${_dom} src='` + `${url}` + "' style='width:100%'>",
        "图片/视频展示",
        {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: "showImage",
          callback: () => {
            // 在弹窗关闭时执行停止视频播放的操作
            const videoElement = document.querySelector(".showImage video");
            if (videoElement) {
              videoElement.pause();
            }
          },
        }
      );
    },
    /** 处理禁止选择时间的方法 */
    handleStartDateChange() {
      // 获取开始时间日期选择器的实例
      const startDatePicker = this.$refs.startDatePicker;

      // 如果开始时间不为空
      if (this.mediaEditData.validStartDate) {
        // 设置结束时间日期选择器的可选日期范围，从开始时间的下一天开始
        startDatePicker.$el.querySelector("input").blur();
        startDatePicker.pickerOptions = {
          disabledDate(time) {
            return time.getTime() <= startDatePicker.currentValue.getTime();
          },
        };
      } else {
        // 如果开始时间为空，则清空结束时间的可选日期范围
        startDatePicker.pickerOptions = {
          disabledDate() {
            return false;
          },
        };
      }
    },
    /** 三方分集信息的事件 */
    handlePartnerDiversity() {
      this.partnerDiversityDialog = true;
    },
    /** 三方片花信息的事件 */
    handlePartnerTrailer() {
      this.partnerTrailerDialog = true;
    },
    //^ ^--------------分集选择对话框内的事件-------------^ ^
    /** 分集详情的事件 */
    handleDiversityDetail(row) {
      console.log("分集详情", row);
      this.diversityDetailData = row;
      this.diversityDetailData.feeMode =
        this.diversityDetailData.episodeMovie.feeMode;
      this.diversityDetailDialog = true;
    },
    /** 分集预览的事件 */
    handleDiversityPreview(row) {
      console.log("分集预览", row);
      this.videoUrl = row.playUrl;
      this.handleAlertPreview(this.videoUrl);
      // this.videoDialogVisible = true
    },
    /** 片花详情的事件 */
    handleTrailerDetail(row) {
      console.log("片花详情", row);
      this.trailerDetailData = row;
      this.trailerDetailDialog = true;
    },
    /** 片花预览的事件 */
    handleTrailerPreview(row) {
      console.log("片花预览", row);
      this.videoUrl = row.playUrl;
      this.handleAlertPreview(this.videoUrl);
      // this.videoDialogVisible = true
    },
    /** 分集搜索 */
    diversitySearch() {
      console.log("分集搜索", this.diversityId, this.diversityName);
      /** 做本地搜索(支持模糊搜索) */
      const diversityId = this.diversityId.trim();
      const diversityName = this.diversityName.trim();
      const list = [...this.mediaEditData.media.episodeList];
      // 如果两个条件都为空，返回全部数据
      if (!diversityId && !diversityName) {
        this.diversityTable = list;
        return;
      }

      // 使用筛选条件过滤数据并赋值给 diversityTable
      this.diversityTable = list.filter((item) => {
        const matchId = !diversityId || String(item.id).includes(diversityId);
        const matchName = !diversityName || item.name.includes(diversityName);
        return matchId && matchName;
      });
      Message.success("搜索成功");
    },
    /** 片花搜索 */
    trailerSearch() {
      console.log("片花搜索", this.trailerId);
      /** 做本地搜索(支持模糊搜索) */
      const trailerId = this.trailerId.trim();
      const list = [...this.mediaEditData.media.trailerList];
      // 如果条件都为空，返回全部数据
      if (!trailerId) {
        this.trailerTable = list;
        return;
      }
      // 使用筛选条件过滤数据并赋值给 diversityTable
      this.trailerTable = list.filter((item) => {
        const matchId = !trailerId || String(item.id).includes(trailerId);
        return matchId;
      });
      Message.success("搜索成功");
    },
    /** 选择片花的事件 */
    handleTrailerRadioChange(selectedRow) {
      console.log("选择片花的事件", selectedRow);
      this.trailerRadioId = selectedRow.id;
      this.mediaEditData.selectTrailer.name = selectedRow.aword;
      this.mediaEditData.selectTrailer.playUrl = selectedRow.playUrl;
    },
    /** 选择分集的事件 */
    handleDiversityRadioChange(selectedRow) {
      console.log("选择分集的事件", selectedRow);
      this.diversityRadioId = selectedRow.id;
      this.mediaEditData.selectEpisode.name = selectedRow.name;
      this.mediaEditData.selectEpisode.playUrl = selectedRow.playUrl;
    },
    /** 分集确认保存的事件 */
    diversitySelectOk() {
      this.addForm.tacticsMedias = this.addForm.tacticsMedias.map((item) => {
        if (item.mediaId == this.diversityRadioId) {
          item.diversityRadioTrueId = this.diversityRadioId;
        }
        return item;
      });
      this.mediaSelectLocalList = [...this.addForm.tacticsMedias];
      this.mediaSelectParams.total = this.mediaSelectLocalList.length;
      this.mediaEditData.episode.id = this.diversityRadioId;
      this.mediaEditData.episode.name = this.mediaEditData.selectEpisode.name;
      this.mediaEditData.episode.playUrl =
        this.mediaEditData.selectEpisode.playUrl;
      this.diversityRadioTrueId = this.diversityRadioId;
      this.diversityId = "";
      this.diversityName = "";
      this.diversitySelectDialog = false;
      console.log("this.mediaEditData", this.mediaEditData);
    },
    /** 分集取消保存的事件 */
    diversitySelectCancel() {
      this.diversityRadioId = "";
      this.diversityRadioTrueId = "";
      this.diversityId = "";
      this.diversityName = "";
      this.diversitySelectDialog = false;
    },
    /** 片花确认保存的事件 */
    trailerSelectOk() {
      console.log("this.mediaEditData", this.mediaEditData);
      this.addForm.tacticsMedias = this.addForm.tacticsMedias.map((item) => {
        console.log("trailerSelectOk-item", item);

        if (item.mediaId == this.trailerRadioId) {
          item.trailerRadioTrueId = this.trailerRadioId;
        }
        return item;
      });
      this.mediaSelectLocalList = [...this.addForm.tacticsMedias];
      this.mediaSelectParams.total = this.mediaSelectLocalList.length;
      this.mediaEditData.trailer.id = this.trailerRadioId;
      this.mediaEditData.trailer.name = this.mediaEditData.selectTrailer.name;
      this.mediaEditData.trailer.playUrl =
        this.mediaEditData.selectTrailer.playUrl;
      this.trailerRadioTrueId = this.trailerRadioId;
      this.trailerRadioId = "";
      this.trailerSelectDialog = false;
    },
    /** 分集取消保存的事件 */
    trailerSelectCancel() {
      this.trailerRadioId = "";
      this.trailerRadioTrueId = "";
      this.trailerId = "";
      this.trailerSelectDialog = false;
    },
    //^ ^------------媒资编辑对话框内的事件---------------^ ^ */
    /** 关闭对话框的事件 */
    mediaEditClose() {
      /** 清理数据 */
      this.mediaEditData = {
        episodeList: [],
        selectTrailer: {
          id: "",
          name: "",
          playUrl: "",
        },
        trailer: {
          id: "",
          name: "",
          playUrl: "",
        },
        selectEpisode: {
          id: "",
          name: "",
          playUrl: "",
        },
        episode: {
          id: "",
          name: "",
          playUrl: "",
        },
        /** 展示选择 */
        useType: "",
        /** 生效方式 */
        timeWay: [],
        /** 有效开始日期 */
        validStartDate: "",
        /** 有效结束日期 */
        validEndDate: "",
        /** 有效开始时间 */
        validStartTime: "",
        /** 有效结束时间 */
        validEndTime: "",
        media: {
          name: "",
          horizontalImg: "",
          verticalImg: "",
          type: "",
          status: "",
          partnerStatus: "",
          updateTime: "",
        },
      };
      /** 关闭对话框 */
      this.mediaEditDialog = false;
    },
    /** 确认保存的事件 */
    confirmMediaEdit() {
      /** 表单验证是否通过 */
      this.$refs.mediaEditForm.validate((valid) => {
        if (valid) {
          console.log("媒资编辑框保存", this.mediaEditData);
          /** 处理时间格式 */
          if (this.mediaEditData.timeWay.includes("1")) {
            this.mediaEditData.validStartDate = this.mediaEditData
              .validStartDate
              ? moment(this.mediaEditData.validStartDate).format("YYYY-MM-DD")
              : "";
            this.mediaEditData.validEndDate = this.mediaEditData.validEndDate
              ? moment(this.mediaEditData.validEndDate).format("YYYY-MM-DD")
              : "";
          }
          if (this.mediaEditData.timeWay.includes("2")) {
            this.mediaEditData.validStartTime = this.mediaEditData
              .validStartTime
              ? moment(this.mediaEditData.validStartTime).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              : "";
            this.mediaEditData.validEndTime = this.mediaEditData.validEndTime
              ? moment(this.mediaEditData.validEndTime).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              : "";
          }
          /** 把数据根据id 给媒资选择列表里面 */
          console.log("this.mediaSelectList", this.mediaSelectList);
          console.log("this.mediaEditData", this.mediaEditData);
          this.addForm.tacticsMedias = this.addForm.tacticsMedias.map(
            (item) => {
              console.log("item", item, this.mediaEditData.id);
              if (item.id == this.mediaEditData.id) {
                item.myObject = { ...this.mediaEditData };
                item.mySave = true;
                item.validStartDate = this.mediaEditData.validStartDate;
                item.validEndDate = this.mediaEditData.validEndDate;
                try {
                  item.validStartTime = this.mediaEditData.validStartTime.split(
                    " "
                  )[1]
                    ? this.mediaEditData.validStartTime.split(" ")[1]
                    : "";
                  item.validEndTime = this.mediaEditData.validEndTime.split(
                    " "
                  )[1]
                    ? this.mediaEditData.validEndTime.split(" ")[1]
                    : "";
                } catch (error) {
                  item.validStartTime = "";
                  item.validEndTime = "";
                }
                if (this.mediaEditData.useType === 1) {
                  item.useType = 1;
                  item.trailerId = this.mediaEditData.trailer.id;
                  item.myTrailerName = this.mediaEditData.trailer.name;
                  item.myTrailerPlayUrl = this.mediaEditData.trailer.playUrl;
                  item.episodeId = "";
                } else if (this.mediaEditData.useType === 2) {
                  item.useType = 2;
                  item.episodeId = this.mediaEditData.episode.id;
                  item.myEpisodeName = this.mediaEditData.episode.name;
                  item.myEpisodePlayUrl = this.mediaEditData.episode.playUrl;
                  item.trailerId = "";
                } else if (!this.mediaEditData.useType) {
                  if (
                    item.type === 0 ||
                    item.type === 1 ||
                    item.type === 2 ||
                    item.type === 3
                  ) {
                    item.useType = 1;
                    item.trailerId = this.mediaEditData.trailer.id
                      ? this.mediaEditData.trailer.id
                      : item.firstTrailer
                      ? item.firstTrailer.id
                      : "";
                    item.episodeId = "";
                  } else if (
                    item.type === 4 ||
                    item.type === 5 ||
                    item.type === 6
                  ) {
                    item.useType = 2;
                    item.episodeId = this.mediaEditData.episode.id
                      ? this.mediaEditData.episode.id
                      : item.firstEpisode
                      ? item.firstEpisode.id
                      : "";
                    item.trailerId = "";
                  }
                }
              }
              return item;
            }
          );
          console.log("this.addForm.tacticsMedias", this.addForm.tacticsMedias);
          this.mediaEditClose();
        } else {
          Message.error("表单验证失败");
          return;
        }
      });
    },
    /** 预览的事件 */
    handleMediaEditPreview(mediaEdit) {
      console.log("媒资编辑内预览", mediaEdit);
      if (mediaEdit.useType === 1) {
        this.videoUrl = mediaEdit.trailer.playUrl;
      } else if (mediaEdit.useType === 2) {
        this.videoUrl = mediaEdit.episode.playUrl;
      }
      this.handleAlertPreview(this.videoUrl);
      // this.videoDialogVisible = true
    },
    /** 分集选择的事件 */
    handleDiversitySelect() {
      console.log("分集选择的事件");

      this.diversityTable = [...this.mediaEditData.media.episodeList];

      this.diversitySelectDialog = true;
    },
    /** 片花选择的事件 */
    handleTrailerSelect() {
      console.log("片花选择的事件");

      this.trailerTable = [...this.mediaEditData.media.trailerList];

      this.trailerSelectDialog = true;
    },
    /** avue-curd的刷新事件 */
    async refreshChange() {
      await this.loadList();
      /** 提示用户 */
      Message.success("刷新成功");
    },
    //^ ^--------------已选择popover内的事件-------------^ ^
    /** 移除 */
    selectedDel(row) {
      console.log("移除的数据", row);
      if (!row) {
        /** 全部移除 */
        this.mediaSelectList = [];
        this.selectList = [];
        this.$nextTick(() => {
          this.$refs.mediaTable.clearSelection();
        });
      } else {
        /** 单个移除 */

        /** 从表格内过滤掉id为row.id的数据 */
        let delList = this.mediaSelectList.filter((item) => item.id == row.id);
        this.mediaSelectList = this.mediaSelectList.filter(
          (item) => item.id != row.id
        );
        console.log("移除this.mediaSelectList之后", this.mediaSelectList);
        /** 补充mediaId */
        this.mediaSelectList = this.mediaSelectList.map((item, index) => {
          item.mediaId = item.id;
          item.sort = index + 1;
          return item;
        });
        console.log("delList", delList);
        /** 执行选中的方法 */
        this.$nextTick(() => {
          if (!delList.length) {
            this.mediaTable.forEach((item) => {
              if (item.id === row.mediaId) {
                this.$refs.mediaTable.toggleRowSelection(item, false);
              }
            });
          } else {
            this.mediaTable.forEach((item) => {
              delList.forEach((delItem) => {
                if (item.id === delItem.id) {
                  this.$refs.mediaTable.toggleRowSelection(item, false);
                }
              });
            });
          }

          // delList.forEach((item) => {
          //   this.$refs.mediaTable.toggleRowSelection(item, false)
          // })
        });
      }

      /** 从已选择列表内过滤掉id为row.id的数据 */
      this.selectList = this.selectList.filter((item) => item.id != row.id);
      /** 重新计算已选择的个数 */
      this.selectNum = this.selectList.length;

      /** 移除之后执行一下媒资数据的验证规则 */
      this.$refs.addForm.validateField("tacticsMedias");
    },
    /** 全部移除 */

    //^ ^--------------表格操作栏内的事件-------------^ ^
    /** 编辑的事件 */
    async handleEdit(row) {
      console.log("编辑回填的数据", row);
      /** 调用获取详情的接口 */
      const { data } = await getDetail(row.id).then((res) => {
        this.isEdit = true;
        return res;
      });
      console.log("获取详情的响应", data);
      const detail = { ...data.data };
      // detail.tacticsMedias = detail.tacticsMedias;
      /** 处理数据 */

      detail.tacticsMedias = detail.tacticsMedias.map((item) => {
        item.renderMediaId = item.mediaId;
        item.name = item.media.name;
        item.type = item.media.type;
        item.horizontalImg = item.media.horizontalImgLarge
          ? item.media.horizontalImgLarge
          : item.media.horizontalImgSmall;
        item.partnerName = item.partner.name;
        item.status = item.media.status;
        return item;
      });
      console.log("处理编辑的响应", detail);
      this.addForm = detail;
      this.mediaSelectLocalList = [...this.addForm.tacticsMedias];
      this.mediaSelectParams.total = this.mediaSelectLocalList.length;
      /** 打开对话框 */
      this.addVisible = true;
    },
    /** 删除的事件 */
    detailDel(id) {
      console.log("删除的id", id);
      /** 二次询问 */
      this.$confirm("此操作将永久删除该策略, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        /** 调用删除接口 */
        const { data } = await del(id);
        console.log("删除的响应", data);
        /** 如果成功 */
        if (data.code === 200) {
          /** 提示 */
          Message.success("删除成功");
          /** 重新加载列表 */
          this.loadList();
        }
      });
    },
    //^ ^--------------新增/编辑对话框内的事件-------------^ ^
    /** 每页条数change */
    handleMediaSelectSizeChange(val) {
      this.mediaSelectParams.size = val;
      /** 静态分页 */
      this.addForm.tacticsMedias = this.mediaSelectLocalList.slice(
        (this.mediaSelectParams.current - 1) * val,
        this.mediaSelectParams.current * val
      );
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      // this.loadList();
    },
    /** 当前页change */
    handleMediaSelectCurrentChange(val) {
      this.mediaSelectParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 静态分页 */
      this.addForm.tacticsMedias = this.mediaSelectLocalList.slice(
        (val - 1) * this.mediaSelectParams.size,
        val * this.mediaSelectParams.size
      );
      /** 更新数据 */
      // this.loadList();
    },
    /** 排序的事件 */
    async sortChange(oldindex, newindex, row, list) {
      // this.$message.success(oldindex + ',' + newindex)
      console.log("row", row);
      console.log("list", list);
      /** 只留下分集id */
      const trailerIdList = list.map((item) => {
        return item.id;
      });
      console.log("排序之后的idList", trailerIdList);
    },
    /** 确认保存 */
    confirmSave() {
      console.log("新增/编辑表单里的数据", this.addForm);
      /** 表单验证 */
      this.$refs.addForm.validate(async (valid) => {
        if (valid) {
          /** 验证通过 */
          /** 处理数据 */
          const addParams = { ...this.addForm };
          console.log("新增的数据", addParams);
          /** 频控如果不填就要传0 给接口 */
          if (addParams.dayLimit === "") {
            addParams.dayLimit = 0;
          }
          if (addParams.totalLimit === "") {
            addParams.totalLimit = 0;
          }
          /** 判断是新增还是编辑 */
          if (this.isEdit) {
            addParams.tacticsMedias = addParams.tacticsMedias.map((item) => {
              item.sort = item.$index + 1;
              if (item.media) {
                item.mediaId = item.media.id;
                return {
                  ...item,
                };
              } else {
                return {
                  ...item,
                };
              }
            });
            console.log("处理过后的新增/编辑表单里的数据", addParams);
            if (addParams.isIntervene === 0) {
              addParams.interveneQuantity = 0;
            }
            /** 调用接口 */
            const { data } = await edit(addParams);
            console.log("编辑的响应", data);
            /** 如果成功 */
            if (data.code === 200) {
              /** 关闭对话框 */
              this.closeAddDialog();
              /** 提示 */
              Message.success("编辑成功");
              /** 重新加载列表 */
              this.loadList();
            }
          } else {
            addParams.tacticsMedias = addParams.tacticsMedias.map((item) => {
              item.sort = item.$index + 1;
              item.mediaId = item.id;
              delete item.id;
              /** 根据类型判断传分集还是片花 */
              if (
                item.type === 0 ||
                item.type === 1 ||
                item.type === 2 ||
                item.type === 3
              ) {
                item.trailerId = item.firstTrailer.id
                  ? item.firstTrailer.id
                  : "";
                item.episodeId = "";
                item.useType = 1;
              } else if (
                item.type === 4 ||
                item.type === 5 ||
                item.type === 6
              ) {
                item.episodeId = item.firstEpisode.id
                  ? item.firstEpisode.id
                  : "";
                item.trailerId = "";
                item.useType = 2;
              }
              return {
                ...item,
              };
            });
            console.log("处理过后的新增/编辑表单里的数据", addParams);
            if (addParams.isIntervene === 0) {
              addParams.interveneQuantity = 0;
            }
            /** 调用接口 */
            const { data } = await add(addParams);
            console.log("新增的响应", data);
            /** 如果成功 */
            if (data.code === 200) {
              /** 关闭对话框 */
              this.closeAddDialog();
              /** 提示 */
              Message.success("新增成功");
              /** 重新加载列表 */
              this.loadList();
            }
          }
        } else {
          /** 验证不通过 */
          Message.error("请检查表单是否填写完整");
        }
      });
    },
    /** 编辑已选择媒资的数据 */
    async handleMediaEdit(row) {
      console.log("编辑的数据", row);
      console.log("this.mediaEditData", this.mediaEditData);
      /** 分情况调用不同的接口 */
      if (this.isEdit) {
        if (row.mySelect) {
          /** 查询媒资信息 */
          const { data } = await getMediaInfo(row.id);
          this.mediaEditData = { ...this.mediaEditData, ...data.data };
          /** 修正数据 */
          this.mediaEditData.media.episodeList = data.data.episodeList.map(
            (item) => {
              /** 把this.mediaEditData.movie中的feeMode 赋值给list的item */
              item.feeMode = data.data.movie.feeMode;
              return item;
            }
          );
          this.mediaEditData.media.trailerList = data.data.trailerList.map(
            (item) => {
              /** 把this.mediaEditData.movie中的feeMode 赋值给list的item */
              item.feeMode = data.data.movie.feeMode;
              return item;
            }
          );
          this.mediaEditData.media.id = data.data.id;
          this.mediaEditData.media.name = data.data.name;
          this.mediaEditData.media.horizontalImg = data.data.horizontalImg;
          this.mediaEditData.media.verticalImg = data.data.verticalImg;
          /** 展示选择 */
          if (row.useType === 1) {
            this.mediaEditData.useType = 1;
            this.mediaEditData.trailer.id = row.firstTrailer
              ? row.firstTrailer.id
              : "";
            this.mediaEditData.trailer.name = row.firstTrailer
              ? row.firstTrailer.aword
              : "";
            this.mediaEditData.trailer.playUrl = row.firstTrailer
              ? row.firstTrailer.playUrl
              : "";
          } else if (row.useType === 2) {
            this.mediaEditData.useType = 2;
            this.mediaEditData.episode.id = row.firstEpisode
              ? row.firstEpisode.id
              : "";
            this.mediaEditData.episode.name = row.firstEpisode
              ? row.firstEpisode.name
              : "";
            this.mediaEditData.episode.playUrl = row.firstEpisode
              ? row.firstEpisode.playUrl
              : "";
          }
          this.mediaEditData.media.type = row.type;
          console.log("this.mediaEditData", this.mediaEditData);
          console.log("查询媒资信息的响应", data);
        } else {
          /** 查询媒资信息 */
          const { data } = await getMediaDetail(row.id);
          console.log("查询媒资信息的响应", data);
          this.mediaEditData = { ...this.mediaEditData, ...data.data };
          this.mediaEditData.media.episodeList =
            data.data.media.episodeList.map((item) => {
              /** 把this.mediaEditData.movie中的feeMode 赋值给list的item */
              item.feeMode = data.data.media.movie.feeMode;
              return item;
            });
          this.mediaEditData.media.trailerList =
            data.data.media.trailerList.map((item) => {
              /** 把this.mediaEditData.movie中的feeMode 赋值给list的item */
              item.feeMode = data.data.media.movie.feeMode;
              return item;
            });
          if (data.data.useType === 1) {
            this.mediaEditData.trailer.name = data.data.trailer.aword;
          }
          if (data.data.validDatePeriod) {
            this.mediaEditData.timeWay.push("1");
          }
          if (data.data.validTimePeriod) {
            this.mediaEditData.timeWay.push("2");
          }
          this.mediaEditData.validStartTime = moment(
            `${data.data.validStartTime}`,
            "HH:mm:ss"
          ).toDate();
          this.mediaEditData.validEndTime = moment(
            `${data.data.validEndTime}`,
            "HH:mm:ss"
          ).toDate();
          console.log("this.mediaEditData", this.mediaEditData);
        }
      } else {
        const { data } = await getMediaInfo(row.id);
        this.mediaEditData = { ...this.mediaEditData, ...data.data };
        /** 修正数据 */
        this.mediaEditData.media.episodeList = data.data.episodeList.map(
          (item) => {
            /** 把this.mediaEditData.movie中的feeMode 赋值给list的item */
            item.feeMode = data.data.movie.feeMode;
            return item;
          }
        );
        this.mediaEditData.media.trailerList = data.data.trailerList.map(
          (item) => {
            /** 把this.mediaEditData.movie中的feeMode 赋值给list的item */
            item.feeMode = data.data.movie.feeMode;
            return item;
          }
        );
        this.mediaEditData.media.id = data.data.id;
        this.mediaEditData.media.name = data.data.name;
        this.mediaEditData.media.horizontalImg = data.data.horizontalImg;
        this.mediaEditData.media.verticalImg = data.data.verticalImg;
        /** 展示选择 */
        if (row.useType === 1) {
          this.mediaEditData.useType = 1;
          this.mediaEditData.trailer.id = row.firstTrailer
            ? row.firstTrailer.id
            : "";
          this.mediaEditData.trailer.name = row.firstTrailer
            ? row.firstTrailer.aword
            : "";
          this.mediaEditData.trailer.playUrl = row.firstTrailer
            ? row.firstTrailer.playUrl
            : "";
        } else if (row.useType === 2) {
          this.mediaEditData.useType = 2;
          this.mediaEditData.episode.id = row.firstEpisode
            ? row.firstEpisode.id
            : "";
          this.mediaEditData.episode.name = row.firstEpisode
            ? row.firstEpisode.name
            : "";
          this.mediaEditData.episode.playUrl = row.firstEpisode
            ? row.firstEpisode.playUrl
            : "";
        }
        this.mediaEditData.media.type = row.type;
        console.log("新增查询媒资信息的响应", data);
      }
      if (row.myObject) {
        this.mediaEditData = { ...this.mediaEditData, ...row.myObject };
      }
      console.log("this.mediaEditData", this.mediaEditData);
      /** 媒资编辑对话框显示 */
      this.mediaEditDialog = true;
    },
    /** 移出已经选择的媒资数据 */
    handleMediaDel(row) {
      /** 从表格内过滤掉id为row.id的数据 */
      this.addForm.tacticsMedias = this.addForm.tacticsMedias.filter(
        (item) => item.id !== row.id
      );
      this.mediaSelectLocalList = [...this.addForm.tacticsMedias];
      this.mediaSelectParams.total = this.mediaSelectLocalList.length;
      /** 移除之后执行一下媒资数据的验证规则 */
      this.$refs.addForm.validateField("tacticsMedias");
    },
    /** 关闭对话框 */
    closeAddDialog() {
      this.isEdit = false;
      /** 清理表单数据 */
      this.addForm = {
        name: "",
        descr: "",
        tacticsMedias: [],
        status: "",
        dayLimit: "",
        totalLimit: "",
        /** 图片类型 1横图 2竖图 */
        imgType: 1,
        /** 是否人工干预 */
        isIntervene: 0,
        /** 干预数量 */
        interveneQuantity: "",
      };
      this.mediaSelectLocalList = [];
      /** 清理表单验证规则 */
      this.$refs.addForm.clearValidate();
      /** 关闭对话框 */
      this.addVisible = false;
    },
    //^ ^--------------媒资选择弹窗内的事件-------------^ ^
    /** 预览的事件 */
    handleMediaSelectPreview(row) {
      console.log("预览的事件", row);
      // 预览img，video
      // handleShowImage(url, type) {
      //   console.log('handleShowImage', url, type);
      //   let _dom = type === 'video' ? type + ' controls' : 'img'
      //   this.$alert(`<${_dom} src='` + url + "' style='width:100%'>", '图片/视频展示', {
      //     dangerouslyUseHTMLString: true,
      //     showConfirmButton: false,
      //     customClass: 'showImage',
      //   });
      // },
      /** 判断是电影-1 还是短剧-4 */
      if (!this.isEdit) {
        if (
          row.type === 0 ||
          row.type === 1 ||
          row.type === 2 ||
          row.type === 3
        ) {
          console.log(row.firstTrailer.playUrl);
          this.videoUrl = row.firstTrailer.playUrl;
          if (row.firstTrailer.playUrl === "") {
            Message.error("暂无播放地址");
            return;
          }
          this.handleAlertPreview(this.videoUrl);
          // this.videoDialogVisible = true
        } else if (row.type === 4 || row.type === 5 || row.type === 6) {
          console.log(row.firstEpisode.playUrl);
          if (row.firstEpisode.playUrl === "") {
            Message.error("暂无播放地址");
            return;
          }
          this.videoUrl = row.firstEpisode.playUrl;
          this.handleAlertPreview(this.videoUrl);
          // this.videoDialogVisible = true
        }
      } else {
        if (row.mySelect) {
          if (row.useType === 1) {
            this.videoUrl = row.firstTrailer.playUrl;
            if (row.firstTrailer.playUrl === "") {
              Message.error("暂无播放地址");
              return;
            }
            this.handleAlertPreview(this.videoUrl);
            // this.videoDialogVisible = true
          } else if (row.useType === 2) {
            this.videoUrl = row.firstEpisode.playUrl;
            if (row.firstEpisode.playUrl === "") {
              Message.error("暂无播放地址");
              return;
            }
          }
        } else {
          if (row.useType === 1) {
            this.videoUrl = row.trailer.playUrl;
            if (row.trailer.playUrl === "") {
              Message.error("暂无播放地址");
              return;
            }
            this.handleAlertPreview(this.videoUrl);
            // this.videoDialogVisible = true
          } else if (row.useType === 2) {
            this.videoUrl = row.episode.playUrl;
            if (row.episode.playUrl === "") {
              Message.error("暂无播放地址");
              return;
            }
          }
        }
        this.handleAlertPreview(this.videoUrl);
        // this.videoDialogVisible = true
      }
    },
    /** 媒资选择按钮 */
    handleMediaSelect() {
      this.mediaSelectVisible = true;
      this.mediaSelectList = this.mediaSelectLocalList;
      // this.mediaSelectList = this.addForm.tacticsMedias;
      this.getMediaList();
      /** 选中回显 */
      // this.$refs.mediaTable.clearSelection();
      console.log("选中回显的数据", this.addForm);
      console.log(
        "this.mediaSelectList",
        this.addForm.tacticsMedias,
        this.mediaTable
      );
      /** 匹配列表 */
      // this.$nextTick(() => {
      //   this.addForm.tacticsMedias.forEach((item) => {
      //     this.mediaTable.forEach((item2) => {
      //       if (item.id === item2.id) {
      //         this.$refs.mediaTable.toggleRowSelection(item2);
      //       }
      //     })
      //   })
      // })
      // this.$nextTick(() => {
      //   this.addForm.tacticsMedias.forEach(item => {
      //     console.log("item", item);
      //     console.log("this.$refs.mediaTable", this.$refs.mediaTable);
      //     this.$refs.mediaTable.toggleRowSelection(item);

      //     // this.$refs.mediaTable.toggleRowSelection(item);
      //   });
      // })
    },
    /** 选择媒资数据触发的事件 */
    handleSelectionChange(val, row) {
      console.log("val", val);
      console.log("row", row);
      console.log("handleSelectionChange-前", this.mediaSelectList);

      const index = this.mediaSelectList.findIndex(
        (item) => item.id === row.id
      );
      /** 如果row 在val 列表里 说明是删除 否则是选中 */
      if (val.findIndex((item) => item.id === row.id) >= 0) {
        /** 选中的情况 （且选中这一项已经在this.mediaSelectList）  去重*/
        if (index >= 0) {
          this.mediaSelectList.splice(index, 1, row);
        } else {
          /** 不在this.mediaSelectList 直接push */
          this.mediaSelectList.push(row);
          row.mySelect = true;
        }
      } else {
        /** 不是选中的情况 直接删除 */
        index >= 0 && this.mediaSelectList.splice(index, 1);
      }
      console.log("handleSelectionChange-后", this.mediaSelectList);
      /** 原本的id 变成了mediaId */
      this.mediaSelectList = this.mediaSelectList.map((item) => {
        return {
          ...item,
          mediaId: item.id,
        };
      });
      this.selectList = [...this.mediaSelectList];
      this.selectNum = this.mediaSelectList.length;
    },
    /** 全选媒资的事件 */
    selectAll(val) {
      console.log("全选的val", val);
      console.log("selectAll-前", this.mediaSelectList);
      /** 如果是全选 */
      if (val.length) {
        this.mediaSelectList = [...val];
      } else {
        /** 如果是取消全选 */
        this.mediaSelectList = [];
      }
      console.log("selectAll-后", this.mediaSelectList);
      this.mediaSelectList = this.mediaSelectList.map((item) => {
        if (!item.mySelect) {
          item.mySelect = true;
          item.mediaId = item.id;
        }
        return item;
      });
      this.selectNum = this.mediaSelectList.length;
      this.selectList = [...this.mediaSelectList];
    },
    /** 确认选择 */
    mediaIdSelectOk() {
      /** 如果为空 提示请选择数据 */
      // if (!this.mediaSelectList.length) {
      //   Message.error("请选择数据");
      //   return;
      // }
      console.log("this.mediaEditData", this.mediaEditData);
      console.log("选择的媒资数据", this.mediaSelectList);
      /** 处理新选择的媒资数据 */
      this.mediaSelectList = this.mediaSelectList.map((item) => {
        if (item.mySelect) {
          item.mediaId = item.id;
          item.sort = Number(item.$index) + 1;
          if (
            item.type === 0 ||
            item.type === 1 ||
            item.type === 2 ||
            item.type === 3
          ) {
            item.trailerId = this.mediaEditData.trailer.id
              ? this.mediaEditData.trailer.id
              : item.firstTrailer
              ? item.firstTrailer.id
              : item.trailer
              ? item.trailer.id
              : "";
            if (!item.trailerId) {
              item.useType = 2;
              item.episodeId = this.mediaEditData.episode.id
                ? this.mediaEditData.episode.id
                : item.firstEpisode
                ? item.firstEpisode.id
                : item.episode
                ? item.episode.id
                : "";
            } else {
              item.useType = 1;
              item.episodeId = "";
            }
          } else if (item.type === 4 || item.type === 5 || item.type === 6) {
            item.episodeId = this.mediaEditData.episode.id
              ? this.mediaEditData.episode.id
              : item.firstEpisode
              ? item.firstEpisode.id
              : item.episode
              ? item.episode.id
              : "";
            if (!item.episodeId) {
              item.trailerId = this.mediaEditData.trailer.id
                ? this.mediaEditData.trailer.id
                : item.firstTrailer
                ? item.firstTrailer.id
                : item.trailer
                ? item.trailer.id
                : "";
              item.useType = 1;
            } else {
              item.useType = 2;
              item.trailerId = "";
            }
          }
          console.log("选中的item", item);
        }

        return item;
      });
      console.log("处理后的媒资数据", this.mediaSelectList);
      /** 赋值给新增对话框内的媒资数据 */
      this.addForm.tacticsMedias = this.mediaSelectList;
      this.mediaSelectLocalList = [...this.addForm.tacticsMedias];
      this.mediaSelectParams.total = this.mediaSelectLocalList.length;
      /** 关闭对话框 */
      this.closeSelectDialog();
    },
    /** 关闭对话框 */
    closeSelectDialog() {
      /** 清理搜索的数据 */
      this.mediaSearchParams = {
        current: 1,
        size: 10,
        total: 50,
        type: "",
        search: "",
        status: 1,
      };
      /** 清理数据的选中状态 */
      this.$refs.mediaTable.clearSelection();
      /** 验证媒资列表的规则 */
      this.$refs.addForm.validateField("tacticsMedias");
      /** 关闭对话框 */
      this.mediaSelectVisible = false;
      this.mediaSelectList = [];
    },
    /** 搜索事件 */
    mediaSearch() {
      this.searchParams.current = 1;
      this.getMediaList();
      /** 提示用户 */
      Message.success("搜索成功");
    },
    /** 每页条数change */
    mediaSizeChange(val) {
      this.mediaSearchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.getMediaList();
    },
    /** 当前页change */
    mediaCurrentChange(val) {
      this.mediaSearchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.getMediaList();
    },
    //^ ^--------------搜索栏内相关的事件-------------^ ^
    /** 点击新增按钮的事件 */
    handleAdd() {
      this.addVisible = true;
      /** 清理规则 */
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate();
      });
    },
    // ^ ^--------------分页相关-------------^ ^
    /** 加载数据 */
    async loadList() {
      const { data } = await getList(this.searchParams);
      console.log("分页查询接口的响应", data);
      this.searchParams.total = data.data.total;
      this.list = data.data.records;
    },
    /** 搜索事件 */
    handleSearch() {
      this.loadList();
      /** 提示用户 */
      Message.success("搜索成功");
    },
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      this.loadList();
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      this.loadList();
    },
    //^ ^--------------初始化数据-------------^ ^
    /** 获取媒资来源  */
    async loadMediaSource() {
      const { data } = await getMediaSource();
      console.log("媒资来源的数据", data.data);
      this.mediaSourceList = data.data.records;
      this.mediaSelectParams.total = data.data.total;
      /** 本地分页 */
    },
    /** 获取媒资选择列表的数据 */
    async getMediaList() {
      const { data } = await getMediaList(this.mediaSearchParams);
      console.log("媒资选择列表的数据", data);
      this.mediaSearchParams.total = data.data.total;
      this.mediaTable = data.data.records.map((item) => {
        item.renderMediaId = item.id;
        return item;
      });
      this.mediaSelectList.forEach((item) => {
        item.mediaId = item.media ? item.media.id : item.id;
      });
      console.log("a", this.mediaSelectList);
      this.selectList = this.mediaSelectList.map((item) => {
        item.renderMediaId = item.media ? item.media.id : item.id;
        return item;
      });
      this.selectNum = this.selectList.length;
      /** 进行匹配选中 */
      /** 匹配列表 */
      this.$nextTick(() => {
        this.mediaSelectList = this.mediaSelectList.map((item) => {
          const item2 = data.data.records.find(
            (item2) => item2.id === item.mediaId
          );
          if (item2) {
            return merge(item2, item, { renderMediaId: item.mediaId });
          }
          return item;
        });
        this.mediaSelectList.forEach((item) =>
          this.$refs.mediaTable.toggleRowSelection(item)
        );
      });
      // this.mediaTable.forEach((item) => {
      //   this.addForm.tacticsMedias.forEach((item2) => {
      //     if (item.id === item2.id) {
      //       this.$refs.mediaTable.toggleRowSelection(item);
      //     }
      //   })
      // })
    },
  },
};
</script>

<style lang="scss">
.media-select {
  .avue-crud__pagination {
    display: none;
  }
  &,
  .el-form-item__content {
    // display: flex;
    width: 100% !important;
    // display: block !important;
  }
}
</style>

<style lang="scss" scoped>
::v-deep .error-update {
  .el-form-item__error {
    width: 100px;
  }
}
.green-text {
  color: #64bd64;
}

.gary-text {
  color: gray;
}

.tips {
  position: relative;
}

.tips::before {
  content: "媒资播放超时长的1/2，算作一次有效播放";
  position: absolute;
  top: 35px;
  left: -15vw;
  width: 30vw;
  height: 16px;
  font-size: 12px;
  color: gray;
}

.tips2 {
  position: relative;
}

.tips2::before {
  content: "超过频控，媒资会在播放列表里移除";
  position: absolute;
  top: 35px;
  left: -15vw;
  width: 30vw;
  height: 16px;
  font-size: 12px;
  color: gray;
}

.search-contain {
  display: flex;
  // justify-content: space-between;
  align-items: center;
}

.search-left {
  display: flex !important;
  // justify-content: space-between !important;
  align-items: center !important;
}

//^ ^--------------新增/编辑 对话框的样式-------------^ ^
.add-title {
  position: relative;
  margin: 0;
  padding: 0;
  // font-size: 14px;
  font-weight: 700;
  color: #333;
}

.add-title::before {
  content: "";
  position: absolute;
  top: 17px;
  left: -5px;
  width: 3px;
  height: 14px;
  background-color: #15a2f2;
}

.add-item {
  // width: 100%;
  background-color: #f7f7f7;
  padding: 8% 0 5% 5%;

  ::v-deep .el-textarea__inner {
    padding-right: 55px !important;
    max-height: 100px !important;
  }
}

//^ ^--------------avue-crud的样式-------------^ ^
::v-deep .avue-crud__menu {
  display: none;
}

::v-deep .avue-crud .el-card {
  padding: 0 !important;
  overflow: auto !important;
}

.avue-crud .avue-input-number,
.avue-crud .el-cascader,
.avue-crud .el-date-editor.el-input,
.avue-crud .el-date-editor.el-input__inner,
.avue-crud .el-select,
.avue-form .avue-input-number,
.avue-form .el-cascader,
.avue-form .el-date-editor.el-input,
.avue-form .el-date-editor.el-input__inner,
.avue-form .el-select {
  width: 70% !important;
}

::v-deep .avue-form__menu--center {
  display: none !important;
}

::v-deep .avue-form__group .el-col-md-6 {
  width: 100%;
}

::v-deep .avue-form__group .el-form-item__content {
  margin-left: 0px !important;
}

::v-deep
  .avue-crud
  .avue-crud__search
  .avue-form
  .avue-form__group
  .avue-form__row
  .el-form-item
  label {
  float: none;
  display: inline-block;
}
</stylel>
